import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

pageTitleStyles.brandStyles = {
    logoImage: {
        css: css`
            padding: 30px 15px;
            border-radius: 10px;
            border: 1px solid #cccccc;
            img {
                max-width: 150px;
                max-height: 150px;
            }
        `,
    },
    nameText: {
        size: 16,
        weight: "normal",
    },
};

pageTitleStyles.brandGridItem = {
    width: 12,
    css: css`
        margin-bottom: 15px !important;
    `,
};
